import palette from '../theme/palette';

const styleOverrides = {
  root: {
    ['&.backdrop']: {
      backgroundColor: palette.backdrop,
    }
  },
};

export default styleOverrides;
